import ErrorFallback from 'Components/ErrorFallback'
import { DynamicDrawerMenu } from 'Components/Layout/DrawerMenu/DynamicDrawerMenu'
import SchoolDrawerMenuContent from 'Services/ControlDataManagement/Features/School/Components/SchoolDrawerMenuContent'
import {
  SchoolCalendarCreatePage,
  SchoolCalendarEditPage,
  SchoolCalendarListPage
} from 'Services/ControlDataManagement/Features/SchoolCalendar/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function SchoolCalendarRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <DynamicDrawerMenu drawerMenuContent={<SchoolDrawerMenuContent />} />
      <Routes>
        <Route index element={<SchoolCalendarListPage />} />
        <Route path="create" element={<SchoolCalendarCreatePage />} />
        <Route path=":id/edit" element={<SchoolCalendarEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default SchoolCalendarRoot
